import { Controller } from '@hotwired/stimulus'
import fetchWithHandlingLoginRedirect from '../modules/utils/fetchWithHandlingLoginRedirect'

export default class AutoSubmitController extends Controller {
  connect () {
    document.querySelectorAll('.dropdown').forEach(dropdown => {
      $(dropdown).dropdown({
        onChange: () => {
          const form = dropdown.closest('form')
          const data = new FormData(form)

          fetchWithHandlingLoginRedirect(form.action, {
            method: 'POST',
            body: data,
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
        }
      })
    })
  }
}
